import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Grid, Header, Segment, Icon, Divider } from 'semantic';
import { Breadcrumbs } from 'components';
import { useUser } from 'contexts/user';
import { OCPP_SERVER_ADDR } from 'utils/env';

export default function SandboxDetails() {
  const { provider } = useUser();
  const { t } = useTranslation();
  return (
    <>
      <Container>
        <Breadcrumbs active={t('sandbox.title', 'Sandbox')} />
        <Header as="h1" style={{ marginBottom: '0', fontWeight: 'normal' }}>
          {t('sandbox.title', 'Sandbox')}
        </Header>
        <Segment style={{ padding: '2rem' }}>
          <Icon name="box-archive" size="large" style={{ fontSize: '32px' }} />
          <Header as="h1" style={{ marginBottom: '0', fontWeight: 'normal' }}>
            {t('sandbox.welc', 'Welcome to your sandbox environment')}
          </Header>
          <p style={{ paddingTop: '0.5rem' }}>
            {t('sandbox.context', 'Test & explore Road platform capabilities')}
          </p>
        </Segment>
        <Grid columns={2} divided>
          <Grid.Column>
            <Segment style={{ padding: '2rem' }}>
              <Icon name="settings" size="large" />
              <Header as="h2" style={{ margin: '0' }}>
                {' '}
                {t('sandbox.settings', 'Sandbox settings')}
              </Header>
              <p style={{ paddingTop: '0.5rem' }}>
                {t('sandbox.settingsDescription', 'Configure your environment')}
              </p>
              <a
                style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}
                href="sandbox/settings/look-and-feel">
                <p>{`Go to settings -->`}</p>
              </a>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment style={{ padding: '2rem' }}>
              <Icon name="code" size="large" />
              <Header as="h2" style={{ margin: '0' }}>
                {' '}
                {t('sandbox.credentials', 'API Credentials')}
              </Header>
              <p style={{ paddingTop: '0.5rem' }}>
                {t('sandbox.credentialsDescription', 'Start your integration')}
              </p>
              <a
                style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}
                href="sandbox/credentials">
                <p>{`View credentials -->`}</p>
              </a>
            </Segment>
          </Grid.Column>
        </Grid>
        <Divider />
        <Header as="h1" style={{ margin: '0' }}>
          {t('sandbox.resources', 'Resources')}
        </Header>
        <p style={{ padding: '0.5rem 0 1rem 0' }}>
          {t(
            'sandbox.resourcesDescription',
            'Learn to manage charging stations, charge transcations, charge cards & exchange locations, tokens and transactions as a roaming partner.'
          )}
        </p>
        <Grid columns={2} divided>
          <Grid.Column>
            <Segment style={{ padding: '2rem' }}>
              <Icon name="settings" size="large" />
              <Header as="h2" style={{ margin: '0' }}>
                {' '}
                {t('sandbox.documentation', 'API Documentation')}
              </Header>
              <p style={{ paddingTop: '0.5rem' }}>
                {t('sandbox.documentationDescription', 'Explore our APIs')}
              </p>
              <a
                style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}
                href="https://documentation.road.io/docs/getting-started"
                target="_blank">
                <p>{`Read more -->`}</p>
              </a>
            </Segment>
          </Grid.Column>
          <Grid.Column>
            <Segment style={{ padding: '2rem' }}>
              <Icon name="charger" size="large" />
              <Header as="h2" style={{ margin: '0' }}>
                {' '}
                {t('sandbox.simulator', 'Charge Station Simulator')}
              </Header>
              <p style={{ paddingTop: '0.5rem' }}>
                {t(
                  'sandbox.simulatorDescription',
                  'Run a charging station in your browser'
                )}
              </p>
              <a
                style={{ color: 'var(--primary-color)', fontWeight: 'bold' }}
                target="_blank"
                href={`https://chargestation.one/?ocppBaseUrl=${OCPP_SERVER_ADDR}/1.6/${provider?.slug}&Identity=ChargingStationSimulator`}>
                <p>{`Run simulator -->`}</p>
              </a>
            </Segment>
          </Grid.Column>
        </Grid>
      </Container>
    </>
  );
}
